import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-workflow-status',
  templateUrl: './workflow-status.component.html',
  styleUrls: ['./workflow-status.component.css']
})
export class WorkflowStatusComponent implements OnInit {
  @Input() overallActivityList: any = [];
  @Input() criticalActivityList: any = [];
  @Input() charttabledata: any;
  @Output() public tableOpened: EventEmitter<any> = new EventEmitter<any>();
  constructor(private dataService: DataService, public commonService: CommonService) { }

  ngOnInit(): void {
  }

  getTabularData(item) {
    this.tableOpened.emit(item);
  }
}
